module.exports = __webpack_public_path__ + "img/dictaphone.30258aae.png";